import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Georgia = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Georgia Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. No specific disclosure form; sellers must answer buyer questions
          honestly.
        </Text>

        <Text style={styles.listItem}>
          2. Closing Attorney: Required to conduct real estate closings.
        </Text>

        <Text style={styles.listItem}>
          3. Seller Disclosure Statement: Standard practice, though not mandated
          by law.
        </Text>

        <Text style={styles.listItem}>
          4. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          5.{' '}
          <Text style={styles.underline}>
            Seller's Property Disclosure Statement
          </Text>{' '}
          – Though not specifically required by law, sellers must disclose any
          material defects to a potential buyer.
        </Text>
      </View>
    </View>
  );
};

export default Georgia;
